import { useShadowRootElements } from '@backstage/plugin-techdocs-react';
import { Portal } from '@material-ui/core';
import { RelatedPages } from './RelatedPages';
import { PageTags } from './PageTags';

const CONTENT_FOOTER_CONTAINER_ID = 'af-techdocs-content-footer-container';

export const ContentFooterAddon = () => {
  const [content] = useShadowRootElements(['article.md-content__inner']);
  let container: HTMLDivElement | null = content?.querySelector(
    `#${CONTENT_FOOTER_CONTAINER_ID}`,
  );
  if (!container && content) {
    container = document.createElement('div');
    container.setAttribute('id', CONTENT_FOOTER_CONTAINER_ID);
    content.insertAdjacentElement('beforeend', container);
  }
  return (
    <Portal container={container}>
      <PageTags />
      <RelatedPages />
    </Portal>
  );
};
